import { Splide } from "@splidejs/splide";
import { tagsSlider } from "./sliders";

export default class TagsSlider {
    private section: HTMLElement;
    private tagsWrapper: HTMLElement | null;
    private slider: Splide | null = null;

    constructor(section: HTMLElement) {
        this.section = section;
        this.tagsWrapper = this.section.querySelector("#tags-slider");

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.tagsWrapper) return;

        const slidersCount = [...this.tagsWrapper.querySelectorAll(".splide__slide")] as HTMLLIElement[];

        if (!slidersCount) return;

        this.slider = tagsSlider(this.tagsWrapper, slidersCount.length);
    };
}
